import { render } from "./ApplySave.vue?vue&type=template&id=36525686&scoped=true"
import script from "./ApplySave.vue?vue&type=script&lang=js"
export * from "./ApplySave.vue?vue&type=script&lang=js"

import "./ApplySave.vue?vue&type=style&index=0&id=36525686&lang=css"
import "./ApplySave.vue?vue&type=style&index=1&id=36525686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36525686"]])

export default __exports__